import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=3252e8fc&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"
import style0 from "./courseList.vue?vue&type=style&index=0&id=3252e8fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252e8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3252e8fc')) {
      api.createRecord('3252e8fc', component.options)
    } else {
      api.reload('3252e8fc', component.options)
    }
    module.hot.accept("./courseList.vue?vue&type=template&id=3252e8fc&scoped=true", function () {
      api.rerender('3252e8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/personalDetail/courseList.vue"
export default component.exports